import { Model } from '@/models/Model';

export class Rpc extends Model
{
  protected $name: string = 'Rpc';
  protected $endpoint: string = '/rpc';
  protected $fillable: string[] = ['signature', 'body'];

  public signature?: string;
  public body?: any;

  public execute(signature: string, body: object) {
    const url = `${this.$endpoint}`;

    return this.request('post', url, {
      signature,
      body
    }, false);
  }
}
